import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CalendarDays } from "lucide-react";
import { forwardRef } from "react";
import cn from "../../../utils/cn";
import Button from "../../Button";
const DatePickerTrigger = forwardRef(({ value, onClick, open }, ref) => {
    const getLabel = () => {
        const label = value?.toLocaleString("pt-BR").split(" - ").filter(Boolean);
        if (!label)
            return "";
        if (label[0] === label[1])
            return label[0];
        return label.join(" - ");
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { ref: ref, variant: "outlined", size: "condensed", color: "secondary", className: cn(open && "bg-gray-lightest"), startIcon: _jsx(CalendarDays, {}), onClick: onClick, children: getLabel() }), _jsx("div", { id: "datepicker-portal" })] }));
});
DatePickerTrigger.displayName = "DatePickerTrigger";
export default DatePickerTrigger;
